module.exports = __webpack_public_path__ + "static/media/6H.a8cbe6c1.svg";